import * as React from 'react';
import classnames from 'classnames';
import { MediaQuery, Button } from '@grandvisionhq/common';
import { useLink } from '@grandvisionhq/frk-routing';
import { PaymentMethod, ApplePayButton } from '@grandvisionhq/payments';
import { useIntl } from '@grandvisionhq/state';
import { StepNames } from '../../models/shared.js';

const Footer = ({ onPrevStep , onNextStep , prevStepDisabled , nextStepDisabled , stepName , isFirstStep , selectedPaymentMethod , nextStepHidden ,  })=>{
    const { getLabel  } = useIntl();
    const { onClick: navigateToCartPage  } = useLink({
        route: 'cart.overview'
    }, {
        replace: true
    }) || {};
    const breakPoint = MediaQuery.useBreakpoint();
    return /*#__PURE__*/ React.createElement("div", {
        className: "checkout-footer"
    }, /*#__PURE__*/ React.createElement(Button, {
        variant: "outline",
        size: breakPoint === MediaQuery.BreakpointName.TABLET_LANDSCAPE ? 'small' : undefined,
        color: "primary",
        caption: isFirstStep ? getLabel('checkout.actions.backToStore') : getLabel('checkout.actions.previousStep'),
        className: classnames({
            'button--full-width': nextStepHidden
        }),
        "data-t": `button-previous-${stepName}`,
        disabled: prevStepDisabled,
        onClick: isFirstStep ? navigateToCartPage : onPrevStep
    }), !nextStepHidden && (selectedPaymentMethod === PaymentMethod.APPLE_PAY ? /*#__PURE__*/ React.createElement(ApplePayButton, {
        type: "regular-checkout",
        onClick: onNextStep,
        disabled: nextStepDisabled
    }) : /*#__PURE__*/ React.createElement(Button, {
        color: "primary",
        size: breakPoint === MediaQuery.BreakpointName.TABLET_LANDSCAPE ? 'small' : undefined,
        caption: stepName === StepNames.Payment ? getLabel('checkout.actions.completeOrder') : getLabel('checkout.actions.nextStep'),
        "data-t": `button-next-${stepName}`,
        disabled: nextStepDisabled,
        onClick: onNextStep
    })));
};

export { Footer };
//# sourceMappingURL=Footer.js.map
